import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=e2fceaf4&scoped=true&"
import script from "./ClientList.vue?vue&type=script&lang=js&"
export * from "./ClientList.vue?vue&type=script&lang=js&"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=e2fceaf4&lang=scss&scoped=true&"
import style1 from "./ClientList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fceaf4",
  null
  
)

export default component.exports